import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { Title } from 'components/ModalDialog/style';
import { PlaceholderTitle } from 'common/styles';
import { ButtonVariant } from 'modules/core/enums';
import { useTranslation } from 'react-i18next';

import { CloseButton, CloseIcon, TradeMark } from '../../styles';
import { FailedBlock } from './styles';

export const LoanVariablesFailedBlock: FC<{
  handleHideWithResetVehicle: () => void;
  headerTitle: () => JSX.Element;
}> = ({ handleHideWithResetVehicle, headerTitle }) => {
  const { t } = useTranslation();

  return (
    <FailedBlock>
      <Modal.Header>
        <Title $uppercase>{headerTitle()}</Title>
        <TradeMark>{t('common.symbols.tradeMark')}</TradeMark>
        <CloseButton buttontheme={ButtonVariant.OUTLINE} onClick={handleHideWithResetVehicle}>
          {t('components.loanVariablesModal.buttons.closeToChangeVehicle')}
          <CloseIcon />
        </CloseButton>
      </Modal.Header>
      <Modal.Body>
        <PlaceholderTitle>{t('common.errorMessages.failedRequestMessage')}</PlaceholderTitle>
      </Modal.Body>
    </FailedBlock>
  );
};
